import { dashboardChinese } from './dashboard.ts';
// zh-CN 是应用唯一生效语言。目录值必须与原硬编码字面量逐字一致，
// 以保证按中文 accessible name 定位的浏览器测试不受影响。
export default {
  dashboard: dashboardChinese,
  common: {
    loading: '正在加载…',
    retry: '重试',
    cancel: '取消',
    close: '关闭',
    create: '创建',
    refresh: '刷新',
    actions: '操作',
    empty: '当前范围内暂无记录。',
    previous: '上一页',
    next: '下一页',
    pagination: '{page} / {pages} · 共 {total} 条',
    paginationLabel: '表格分页',
    none: '暂无',
    networkError: '无法连接服务，请检查网络后重试',
    requestFailed: '请求失败，请稍后重试',
    diagnostics: '诊断信息',
    code: '错误码',
    traceId: '追踪号',
    rawMessage: '原始消息',
    unsavedCloseConfirm: '表单尚未提交，确定关闭吗？',
    downloadExpired: '下载失败或已过期',
  },
  nav: {
    overview: '概览',
    metrics: '指标目录',
    'metric-import': '指标导入',
    query: '指标问数',
    governance: '确认与发布',
    metadata: '元数据中心',
    knowledge: '知识库',
    targets: '目标管理',
    tasks: '执行任务',
    dashboards: '看板设计器',
    dashboardDatasets: '看板数据集',
    sources: '数据接入',
    'dw-builder': '数仓构建',
    'business-objects': '业务对象',
    exports: '数据导出',
    users: '用户与身份',
    dingtalk: '钉钉组织同步',
    platformSettings: '平台设置',
    roles: '角色与权限',
    audit: '审计与门禁',
  },
  layout: {
    brand: '福瑞Compass',
    brandSubtitle: '经营数据平台',
    eyebrow: '福瑞Compass / 工作台',
    connected: '已连接',
    mainNav: '主导航',
    themeToggle: '切换主题',
    themeMenu: '主题外观',
    themeDark: '深色',
    themeLight: '浅色',
    themeBlue: '蓝白',
    logout: '退出登录',
    expandSidebar: '展开侧边栏',
    collapseSidebar: '收起侧边栏',
    logoutConfirmTitle: '确认退出登录',
    logoutConfirmBody: '退出后需要重新验证身份才能继续访问。',
    confirmLogout: '确认退出',
    language: '语言',
    langZh: '简体中文',
    langEn: 'English',
    accountMenu: '账号菜单',
    appVersion: '系统版本',
  },
  routeState: {
    forbiddenTitle: '无访问权限',
    featureDisabledTitle: '业务对象功能未启用',
    unavailableTitle: '服务暂不可用',
    notFoundTitle: '页面不存在',
    forbiddenMessage: '当前账号没有此页面的访问权限，请从导航中选择可访问的功能。',
    featureDisabledMessage: '当前环境未开放此功能，请联系管理员确认功能开关。',
    unavailableMessage: '暂时无法验证登录状态或连接服务，请稍后重试。',
    notFoundMessage: '页面不存在，请从导航中选择功能。',
    backHome: '返回首页',
    login: '登录',
  },
  governance: {
    importMetrics: '导入指标',
    validatePublish: '校验与发布',
    hint: '导入校验通过后，由独立人员确认，再由具备发布权限的人员发布。',
    goWizard: '前往导入向导 →',
  },
  overview: {
    statTotal: '授权指标',
    statComputable: '可计算',
    statPartial: '部分可用',
    statBlocked: '数据缺口',
    availability: '数据可用性',
    availabilityHint: '所有结果遵循已发布口径。缺少来源、映射或确认的指标保持阻断状态。',
    colMetric: '指标',
    colBusinessLine: '业务线',
    colAvailability: '可用性',
    colGap: '缺口',
    actionDetail: '详情',
    drawerTitle: '指标详情',
  },
  metric: {
    tabList: '指标列表',
    tabTree: '指标树',
    catalogTitle: '指标目录',
    treeTitle: '指标树',
    colMetric: '指标',
    colId: 'ID',
    colLevel: '层级',
    colStatus: '状态',
    colCurrentVersion: '当前版本',
    actionDetail: '详情',
    actionLineage: '血缘',
    drawerLineage: '指标血缘',
    drawerDetail: '指标详情',
    metaName: '指标名称',
    metaId: '指标 ID',
    metaLevel: '层级',
    metaStatus: '状态',
    metaBusinessLine: '业务线',
    metaCurrentVersion: '当前版本',
    metaGap: '数据缺口说明',
    lineageLoading: '正在加载血缘…',
    lineageEmpty: '暂无血缘数据',
    lineageTitle: '血缘关系',
    rawTitle: '原始数据',
    viewLineage: '查看血缘',
  },
  metricTree: {
    empty: '暂无指标',
  },
  query: {
    title: '经营问数',
    fieldQuestion: '问题',
    placeholderQuestion: '例如：华东区域本月有效入组达成率如何？',
    searching: '查询中…',
    search: '查询',
    fieldGrain: '时间粒度',
    placeholderGrain: '例如：month',
    fieldBusinessLine: '业务线 ID',
    placeholderBusinessLine: '例如：yibao',
    fieldOrgs: '组织 ID（逗号分隔）',
    placeholderOrgs: '例如：org1,org2',
    fieldStart: '开始日期',
    fieldEnd: '结束日期（不含）',
    resultsTitle: '查询结果',
    clarificationPrefix: '需要澄清：',
    clarification: '请确认一个指标、业务线、时间段和组织范围，然后重试查询。',
    candidatesTitle: '候选指标',
    emptyRows: '查询成功但无数据行',
    metaVersion: '版本',
    metaUpdatedAt: '数据时间',
    metaSource: '来源',
    metaQuality: '质量',
  },
  task: {
    dispatch: '派发任务',
    title: '执行任务',
    colTask: '任务',
    colAssignee: '责任人',
    colSeverity: '优先级',
    colDue: '截止时间',
    colState: '状态',
    actionDetail: '详情 / 处理',
    fieldTitle: '任务标题',
    fieldAssignee: '责任人 ID',
    fieldSeverity: '优先级',
    fieldDue: '截止时间',
    submitDispatch: '派发',
    drawerDetail: '任务详情与处理',
    fieldNextState: '下一状态',
    selectPlaceholder: '请选择',
    fieldEvidence: '处理证据 / 说明',
    hint: '核验需要独立人员。版本冲突时请关闭并刷新列表后重试。',
    updateState: '更新状态',
  },
  mutation: {
    nothingToRetry: '没有可重试的操作',
  },
  target: {
    title: '目标列表',
    create: '新建目标',
    createButton: '创建目标',
    submitting: '提交中…',
    detailTitle: '目标详情',
    actualsTitle: '实际值快照',
    selectPlaceholder: '请选择',
    publishedMetric: '已发布指标',
    fieldMetricId: '指标 ID',
    fieldMetricVersion: '已发布版本 ID',
    fieldUnit: '单位',
    fieldTargetValue: '目标值',
    fieldOwner: '责任人 ID',
    fieldScenario: '场景',
    scenarioTarget: '目标',
    scenarioBudget: '预算',
    scenarioForecast: '预测',
    colMetric: '指标',
    colTargetValue: '目标值',
    colUnit: '单位',
    colStart: '开始',
    colEnd: '结束',
    colOwner: '责任人',
    colState: '状态',
    actionDetail: '详情',
    actionActuals: '实际快照',
    invalidPeriod: '结束日期必须晚于开始日期',
  },
  importReview: {
    colSource: '来源',
    colState: '状态',
    colReview: '审核',
    colRows: '行数',
    colErrors: '错误数',
    actionDetailDiff: '详情 / 差异',
    actionConfirm: '确认',
    actionPublish: '发布',
    drawerConfirm: '确认导入',
    drawerPublish: '发布导入',
    drawerDetail: '导入详情与差异',
    errorsTitle: '校验错误',
    diffsTitle: '与已发布版本的差异',
    rowsTitle: '导入数据',
    fieldDecision: '审核决定',
    decisionConfirm: '确认',
    decisionReject: '拒绝',
    fieldEvidence: '审阅证据',
    fieldTicket: '变更单编号',
    hint: '审核和发布绑定当前版本。若版本已变化，请关闭并刷新列表。',
    submitReview: '提交审核',
    statePublished: '已发布',
    stateValidationFailed: '校验失败',
    stateRejected: '已拒绝',
    stateConfirmed: '已独立确认',
    statePending: '待独立确认',
  },
  source: {
    contractsTitle: '源系统契约',
    colName: '名称',
    colOwner: '责任人',
    colVersion: '版本',
    colState: '状态',
    actionContract: '契约',
    contractLabel: '数据契约',
    runsTitle: '采集与质量',
    colBatch: '批次',
    colQuality: '质量',
    colCompletedAt: '完成时间',
    actionDiagnostics: '诊断',
    diagnosticsLabel: '采集诊断',
  },
  export: {
    title: '异步导出',
    create: '创建导出',
    colFormat: '格式',
    colState: '状态',
    colCreatedAt: '创建时间',
    colExpiresAt: '到期时间',
    actionDetail: '详情',
    actionApprove: '批准导出',
    actionDownload: '下载',
    drawerCreate: '创建导出',
    drawerDetail: '导出详情',
    fieldMetricIds: '指标 ID（逗号分隔）',
    fieldBusinessLine: '业务线 ID',
    fieldOrgs: '组织 ID（逗号分隔）',
    fieldStart: '开始日期',
    fieldEnd: '结束日期（不含）',
    fieldGrain: '时间粒度',
    fieldFormat: '格式',
    grainDay: '日',
    grainMonth: '月',
    grainQuarter: '季',
    grainYear: '年',
    submit: '创建',
    missingFields: '请填写指标 ID 和组织范围',
  },
  audit: {
    tabGates: '生产发布门禁',
    tabRecords: '审计记录',
    gatesTitle: '生产发布门禁',
    ready: '发布证据完整',
    blocked: '发布门禁尚未全部通过',
    colCheck: '检查项',
    colResult: '结果',
    passed: '通过',
    pending: '待完成',
    actionDetail: '详情',
    recordsTitle: '审计记录',
    colTime: '时间',
    colActor: '操作者',
    colAction: '操作',
    drawerTitle: '审计与门禁详情',
  },
  metadata: {
    wizardTitle: '元数据导入向导',
    fieldMetadataType: '元数据类型',
    downloadBlank: '下载空白模板',
    downloadExample: '下载示例模板',
    uploadPrevalidate: '上传并预校验',
    colField: '字段',
    colDesc: '说明',
    colType: '类型',
    colRequired: '必填',
    colExample: '示例',
    yes: '是',
    no: '否',
    jobsTitle: '导入任务',
    drawerTitle: '上传元数据',
    fieldSource: '来源说明',
    fieldFormat: '格式',
    fieldFile: '文件（也可直接粘贴 CSV / JSON）',
    fieldContent: '内容',
    xlsxHint: 'XLSX 导入需要服务端配置文件扫描；未配置时会返回明确错误。',
    submit: '预校验并创建草稿',
    tooLarge: '文件过大，请将单次导入控制在 2 MB 以内',
    chooseXlsx: '请选择 XLSX 文件',
    jsonArray: 'JSON 必须为数据行数组',
  },
  knowledge: {
    fieldBusinessLine: '业务线 ID',
    loadRefresh: '加载 / 刷新',
    emptyHint: '请选择业务线以查看其文档和知识问答。',
    tabDocuments: '文档列表',
    tabQuery: '知识问答',
    tabStatus: '知识库状态',
    tabLint: '质量检查',
    documentsTitle: '知识库文档',
    uploadDocument: '上传文档',
    colDocument: '文档',
    colState: '状态',
    colJob: '任务',
    colCreatedAt: '创建时间',
    colFinishedAt: '完成时间',
    actionDetail: '详情',
    actionJobStatus: '任务状态',
    actionDelete: '删除',
    queryTitle: '知识问答',
    fieldQuestion: '问题',
    searching: '查询中…',
    search: '查询',
    answerTitle: '回答',
    noAnswer: '未找到回答',
    citationsTitle: '引用来源',
    colPage: '页码',
    colQuote: '片段',
    statusTitle: '知识库状态',
    refreshStatus: '刷新状态',
    sync: '同步知识库',
    lintTitle: '质量检查',
    recheck: '重新检查',
    drawerUpload: '上传知识库文档',
    businessLineLabel: '业务线：',
    chooseDocument: '请选择文档',
    businessLineRequired: '请填写具体业务线 ID',
    upload: '上传',
    drawerDelete: '删除知识库文档',
    confirmDelete: '确认删除文档 {name}？',
    confirmDeleteButton: '确认删除',
    drawerDetail: '文档与任务详情',
  },
  login: {
    checking: '正在检查可用登录方式…',
    introOidc: '使用组织统一身份安全访问 福瑞Compass。',
    introLdap: '使用企业目录账号登录。',
    introLocal: '使用本地管理员账号登录。',
    introNone: '尚未配置登录方式。',
    tabsLabel: '登录方式',
    providerOidc: '企业单点登录',
    providerDingtalk: '钉钉',
    providerLdap: 'LDAP 目录',
    providerLocal: '本地 / 管理员',
    cardTitle: '欢迎回到指挥台',
    oidcTitle: '企业身份验证',
    oidcBody: '使用组织统一身份安全访问 福瑞Compass，无需记忆额外密码。',
    continueOidc: '继续使用企业单点登录',
    dingtalkTitle: '钉钉身份验证',
    continueDingtalk: '使用钉钉登录',
    fieldEnterprise: '所属企业',
    ldapTitle: '企业目录登录',
    fieldEnterpriseAccount: '企业账号',
    fieldPassword: '密码',
    fieldAccount: '账号',
    submit: '登录',
    localTitle: '本地账号登录',
    footerAudit: '安全审计已开启',
    footerHelp: '需要帮助？联系管理员',
    sessionInvalid: '登录会话无效，请重新登录',
    showcaseHeadlineA: '让每一次经营判断，',
    showcaseHeadlineB: '都有数据回声。',
    showcaseSubtitle: '把分散的医保经营信号，收束为可追踪、可问数、可执行的决策链路。',
    showcaseAria: '产品能力预览',
    showcaseTabOverview: '概览',
    showcaseTabQuery: '指标问数',
    showcaseTabLoop: '目标与执行闭环',
    showcaseOverviewBar: '经营总览 / 2024 Q4',
    showcaseOverviewHeading: '概览',
    showcaseOverviewLabel: 'NATIONAL OPERATIONS',
    showcaseQueryLabel: 'QUERY RESULT / 0.8 SEC',
    showcaseLoopLabel: 'DECEMBER TARGETS',
    showcasePeriod: '本季度 ▾',
    showcaseMetricEnrollment: '有效入组',
    showcaseMetricActive: '活跃患者',
    showcaseMetricOrgRate: '机构达成率',
    showcaseChartFunnel: '患者漏斗趋势',
    showcaseChartGrowth: '月度增长',
    showcaseQueryBar: '指标问数 / 自然语言查询',
    showcaseQueryPrompt: '华东区域本月有效入组达成率如何？',
    showcaseRunQuery: '运行查询 ↗',
    showcaseQueryResultNote: '较目标高出 4.8 个百分点 · 覆盖 42 家签约机构',
    showcaseTagEastChina: '华东区域',
    showcaseLoopBar: '目标执行 / 闭环追踪',
    showcaseLoopProgress: '整体达成进度',
    showcaseStepSet: '设定目标',
    showcaseStepDone: '已完成 · {date}',
    showcaseStepBreakdown: '拆解责任',
    showcaseStepFollowup: '跟进执行',
    showcaseStepInProgress: '进行中 · {n} 个任务',
    showcaseStepReview: '复盘沉淀',
    showcaseStepNotStarted: '待开始',
  },
  user: {
    create: '创建用户',
    linkIdentity: '绑定企业身份',
    listTitle: '用户列表',
    colUsername: '用户名',
    colDisplayName: '显示名',
    colRoles: '角色',
    colStatus: '状态',
    colAccountType: '账号类型',
    actionDetail: '详情',
    actionEffectiveAccess: '有效权限',
    actionEditAccess: '修改访问范围',
    identitiesTitle: '身份绑定',
    colProvider: '提供方',
    colExternalId: '外部 ID',
    colUser: '用户',
    colRevoked: '已撤销',
    actionUnlink: '撤销绑定',
    drawerEdit: '修改访问范围',
    drawerCreate: '创建企业用户',
    fieldUsername: '用户名',
    fieldDisplayName: '显示名',
    fieldRoles: '角色 ID（逗号分隔）',
    fieldBusinessLines: '已注册业务线 ID（逗号分隔）',
    fieldOrgScope: '已注册组织 ID（逗号分隔）',
    fieldClassifications: '数据分级（public,internal,sensitive）',
    fieldStatus: '状态',
    statusActive: '启用',
    statusDisabled: '停用',
    fieldChangeTicket: '变更单编号',
    hint: '访问范围需独立审核和发布；新企业用户还需要绑定 OIDC 或 LDAP 身份。业务线和组织可在元数据中心注册。',
    submitAccessDraft: '创建访问草案',
    drawerUnlink: '撤销企业身份',
    drawerLink: '绑定企业身份',
    fieldProvider: '提供方',
    fieldExternalId: '外部身份 ID',
    fieldUser: '用户',
    fieldCorp: '所属企业',
    selectCorp: '选择企业',
    selectPlaceholder: '请选择',
    fieldDn: 'LDAP DN',
    fieldReason: '操作原因',
    submitUnlink: '撤销绑定',
    submitLink: '绑定',
    drawerDetail: '用户与身份详情',
    providerDingtalk: '钉钉',
    yes: '是',
    no: '否',
  },
  dingtalk: {
    syncQueued: '同步任务已排队，完成后刷新查看最新目录。',
    mappingDenied: '调整部门映射需要组织策略权限，当前账号仅可查看。',
    enterprise: '企业',
    runFullSync: '执行全量同步',
    working: '处理中…',
    refresh: '刷新',
    unmappedUsers: '未映射的钉钉用户',
    colUser: '用户',
    colEmail: '邮箱',
    colTitle: '职位',
    colDepartment: '部门',
    colCompassUser: 'Compass 用户',
    selectUser: '选择用户',
    bind: '绑定',
    noUnmapped: '暂无未映射用户',
    deptMappings: '部门映射',
    colParent: '上级部门',
    colCompassOrg: 'Compass 组织',
    unmapped: '未映射',
    noDepartments: '暂无已同步部门',
  },
  settings: {
    localTestOnly: '仅本地配置检查（连接需人工验证）',
    title: '平台设置',
    subtitle: '统一管理平台连接与运行参数',
    navAria: '设置命名空间',
    editable: '可编辑',
    governed: '治理管理',
    deployed: '部署管理',
    loading: '正在加载设置…',
    sourceOverride: '管理员覆盖',
    sourceEnvironment: '部署环境',
    sourceAuthoritative: '权威配置',
    closeHistory: '关闭历史记录',
    showHistory: '历史记录',
    resetToInherit: '重置为继承',
    refreshSettings: '刷新设置',
    sourceLabel: '来源',
    recordVersion: '记录版本',
    statusLabel: '状态',
    healthReady: '可用',
    healthRestart: '需重启',
    healthKeyUnavailable: '密钥不可用',
    testTarget: '测试目标',
    runTest: '测试已保存设置',
    manualTestHint: '此设置没有自动远程检查；请按运行手册完成外部验证。',
    managedGoverned: '此配置由已发布的治理策略管理。',
    managedDeployed: '此配置由部署运维管理。',
    openManagement: '打开管理入口',
    historyTitle: '历史记录',
    colRevision: '版本',
    colMode: '模式',
    colChangedFields: '修改字段',
    colTime: '时间',
    colActor: '操作人',
    colAction: '操作',
    rollback: '恢复',
    noHistory: '暂无历史记录',
    namespaceUnavailable: '设置命名空间不可用。',
    save: '保存',
    jsonInvalid: 'JSON 格式有误',
    noticeSaved: '已保存',
    noticeSavedRestart: '已保存，需重启',
    noticeRestored: '已恢复继承配置',
    noticeRollbackCreated: '已创建恢复版本',
    errorConflict: '设置已被其他管理员修改。刷新前，你的表单和恢复内容会保留。',
    confirmDisableLastProvider: '停用身份提供方可能影响登录。仍要继续吗？',
    confirmRefreshDiscard: '刷新将丢弃当前表单，包括尚未保存的秘密替换值。确定刷新吗？',
    confirmReset: '重置后将恢复继承部署环境配置。确定继续吗？',
    confirmRollbackInherit: '该历史记录代表继承，将恢复当前环境基线。确定继续吗？',
    confirmRollbackVersion: '将根据该历史版本创建新的设置版本。确定继续吗？',
    confirmLeaveDirty: '表单有未保存的更改。离开将清除秘密替换值，确定继续吗？',
    test: {
      title: '测试结果',
      historical: '历史结果',
      passed: '全部通过',
      partial: '部分检查完成',
      manual: '需人工检查',
      failed: '检查失败',
      versionPrefix: '版本',
      envConfig: '环境配置',
      defaultTarget: '默认目标',
      checkFallback: '检查',
    },
    secret: {
      configured: '已配置',
      notConfigured: '未配置',
      keepPlaceholder: '留空以保留当前值',
      enterNew: '输入新值',
      clear: '清除',
    },
    activation: {
      runtime: '运行状态',
      desiredVersion: '目标版本',
      currentProcess: '当前进程',
      envConfig: '环境配置',
      scopeResponding: '仅代表当前响应进程',
      scopeUnknown: '进程范围未知',
    },
    dingtalk: {
      newCorp: '新企业',
      corpId: '企业标识',
      corpName: '企业名称',
      appKey: '应用标识',
      agentId: '应用代理编号',
      appSecret: '应用密钥',
      callbackToken: '回调令牌',
      aesKey: '消息加密密钥',
      removeCorp: '移除企业',
      addCorp: '添加企业',
      confirmRemoveLast: '移除最后一家企业将停用钉钉登录，确定继续吗？',
    },
  },
  role: {
    createDraft: '创建角色草案',
    listTitle: '角色列表',
    colRole: '角色',
    colId: 'ID',
    colPermissions: '权限',
    colBuiltin: '内置',
    actionDetail: '详情',
    actionVersions: '版本历史',
    actionClone: '克隆',
    actionEditPermissions: '修改权限',
    groupsTitle: '权限组',
    colGroup: '权限组',
    drawerEdit: '修改角色权限草案',
    drawerCreate: '创建角色草案',
    fieldRoleId: '角色 ID',
    fieldDisplayName: '角色名称',
    fieldCloneSource: '克隆来源（可选）',
    optionDirectPermissions: '直接指定权限',
    fieldPermissions: '权限 ID（逗号分隔；留空使用克隆来源）',
    fieldChangeTicket: '变更单编号',
    hint: '草案需独立审核并发布后生效。内置角色只能克隆。',
    submitDraft: '创建草案',
    drawerDetail: '角色与权限详情',
    yes: '是',
    no: '否',
  },
  import: {
    title: '指标导入向导',
    subtitle: '分步导入、校验并发布指标数据',
    reset: '重置',
    step1Label: '选择文件',
    step1Desc: '上传 XLSX/CSV/JSON',
    step2Label: '配置选项',
    step2Desc: '来源与校验设置',
    step3Label: '校验结果',
    step3Desc: '查看校验详情',
    step4Label: '差异预览',
    step4Desc: '对比变更内容',
    step5Label: '提交发布',
    step5Desc: '确认并发布',
    next: '下一步 →',
    tasksTitle: '导入任务',
  },
  bo: {
    eyebrow: '受治理对象 / 运营',
    title: '业务对象工作台',
    subtitle: '按生命周期、权威来源、新鲜度、身份对账和组织范围查找受治理记录。',
    importObjects: '导入对象',
    createObject: '创建对象',
    filterSearch: '搜索',
    placeholderSearch: '自然键或外部引用',
    model: '模型',
    allModels: '全部模型',
    state: '状态',
    allStates: '全部状态',
    activeState: '启用状态',
    activeAll: '启用和停用',
    activeTrue: '启用',
    activeFalse: '停用',
    freshness: '新鲜度',
    allFreshness: '全部新鲜度',
    optionStale: '过期',
    authority: '权威来源',
    allSources: '全部来源',
    reconciliation: '身份对账',
    optionResolved: '已解决',
    optionUnresolved: '未解决',
    orgScope: '组织范围',
    placeholderOrgId: '组织 ID',
    recordsCount: '{n} 条记录 / 已授权视图',
    scopeHint: '范围和权限由服务端执行。',
    loadingObjects: '正在加载受治理对象',
    colIdentity: '身份',
    colModelOwner: '模型 / 负责人',
    colLifecycle: '生命周期',
    noExternalReference: '无外部引用',
    actionOpen: '打开',
    noMatches: '当前范围内没有匹配对象。',
    modalCreateTitle: '新建受治理对象',
    selectPublishedModel: '选择已发布模型',
    fieldNaturalKey: '自然键',
    fieldOwnerUserId: '负责人用户 ID',
    sourceSystem: '来源系统',
    placeholderSourceSystemId: '来源系统 ID',
    fieldExternalRefId: '外部引用 ID',
    fieldExternalRefCode: '外部引用编码',
    fieldValuesJson: '字段值（JSON）',
    checkActiveRecord: '启用记录',
    modalImportTitle: '校验并加载种子数据',
    fieldPublishedModelVersion: '已发布模型版本',
    selectVersion: '选择版本',
    fieldCsvXlsx: 'CSV/XLSX 文件',
    fieldCsvRows: 'CSV 行',
    btnValidateImport: '校验导入',
    rejectedRows: '{n} 行被拒绝 · 指纹',
    loadResult: '加载结果：',
    placeholderEvidence: '独立确认依据',
    btnRefreshStatus: '刷新状态',
    btnConfirmImport: '确认导入',
    btnLoadSeed: '加载种子数据',
    noticeCreated: '业务对象已创建',
    noticeImportValidated: '导入已通过校验，需由独立审核人确认',
    noticeImportRejected: '导入被拒绝',
    noticeImportConfirmed: '导入已确认',
    importCompleted: '导入完成：新增 {created}，未变更 {unchanged}，冲突 {conflicts}，拒绝 {rejected}',
    fileTooLarge: '文件大小不能超过 10 MB',
    backToList: '← 返回对象列表',
    btnReload: '重新加载',
    btnRetryMutation: '重试本次变更',
    loadingContext: '正在加载对象上下文',
    detailEyebrow: '对象详情 / 已授权视图',
    chipRetired: '已退役',
    railExternalId: '外部标识',
    notLinked: '未关联',
    railOwner: '负责人',
    railProjection: '投影状态',
    projectionLoadFailed: '加载失败',
    projectionNotRequested: '未申请',
    projectionControlled: '受控',
    tabActivity: '活动',
    tabRelations: '关联',
    tabProjection: '投影',
    srcFacts: '来源事实',
    baseInfoTitle: '对象基础信息',
    dtBusinessLine: '业务线',
    dtModelVersion: '模型版本',
    dtDataClassification: '数据分级',
    dtRecordVersion: '记录版本',
    fieldValuesEyebrow: '字段值',
    currentFieldValues: '当前字段值',
    saveObject: '保存对象',
    checkCurrentAvailable: '当前可用',
    fieldNextAction: '下一步',
    retireEyebrow: '退役管理',
    retireTitle: '退役对象',
    retiredTitle: '对象已退役',
    retireHint: '退役与停用状态、工作流状态相互独立。',
    btnRetireReason: '填写原因并退役',
    retiredAudit: '记录已保留用于审计，后续操作已停止。',
    stateChangeEyebrow: '状态变更',
    moveStateTitle: '移动生命周期状态',
    fieldTargetState: '目标状态',
    selectTransition: '选择允许的状态迁移',
    evidenceRequiredSuffix: ' · 需要依据',
    fieldChangeEvidence: '变更依据',
    placeholderTransitionEvidence: '说明此次状态迁移的依据',
    btnApplyTransition: '应用状态迁移',
    stateHistoryEyebrow: '状态历史',
    stateHistoryTitle: '状态变更记录',
    noStateHistory: '暂无状态迁移记录。',
    activityLogEyebrow: '活动日志',
    recordActivityTitle: '记录活动',
    fieldType: '类型',
    fieldOccurredAt: '发生时间',
    fieldEvidenceRef: '依据引用',
    fieldContent: '内容',
    recentActivityEyebrow: '最近活动',
    activityCount: '{n} 条记录',
    noActivity: '暂无活动记录。',
    linkExternalIdentity: '关联外部身份',
    identityHint: '来源引用只能通过本操作并提供依据后变更。',
    fieldExternalId: '外部 ID',
    fieldExternalCode: '外部编码',
    fieldEvidence: '依据',
    btnConfirmReconcile: '确认身份对账',
    contactRoleEyebrow: '联系人角色',
    recordSourceRefTitle: '记录来源引用',
    fieldRole: '角色',
    placeholderRole: '例如：个案负责人',
    fieldSourceRef: '来源引用',
    btnAddContactRole: '添加联系人角色',
    objRelationsEyebrow: '对象关系',
    relatedObjectsTitle: '关联对象',
    fieldRelatedObjectId: '关联对象 ID',
    fieldRelationType: '关系类型',
    fieldDirection: '方向',
    btnAddRelation: '添加关系',
    btnUnlink: '解除关联',
    metricsTasksEyebrow: '指标 / 任务',
    governedAssociations: '受治理的关联',
    metricAssociation: '指标关联',
    reloadMetricAssoc: '重新加载指标关联',
    noMetricAssoc: '暂无可见指标关联。',
    addMetric: '添加指标',
    reloadCatalog: '重新加载目录',
    selectVisibleMetric: '选择可见指标',
    fieldMetricVersionId: '指标版本 ID',
    btnAssociateMetric: '关联指标',
    taskAssociation: '任务关联',
    reloadTaskAssoc: '重新加载任务关联',
    noTaskAssoc: '暂无可见任务关联。',
    addTask: '添加任务',
    selectVisibleTask: '选择可见任务',
    btnAssociateTask: '关联任务',
    noCatalogPermission: '当前账号无指标或任务目录权限。',
    projectionEyebrow: '维度投影',
    projectionBinding: '投影绑定',
    projectionNotRequestedTitle: '尚未申请投影',
    reloadProjection: '重新加载投影',
    projectionOperation: '操作 {operation} · 主键 {key}',
    projectionSurrogate: '代理键 {key}',
    projectionHint: '请通过受治理的数仓流程申请投影。',
    projectionControlledTitle: '投影能力受控',
    projectionControlledHint: '当前账号或环境尚未开放维度投影，请联系管理员确认权限和功能开关。',
    retireModalTitle: '确认退役对象',
    retireModalHint: '这会禁止后续对象操作，同时保留记录和退役原因用于审计。',
    placeholderRetireReason: '退役原因',
    noticeObjectSaved: '对象变更已保存',
    noticeRetired: '对象已退役',
    noticeMutationRetried: '变更已重试',
    noticeStateUpdated: '生命周期状态已更新',
    noticeActivityRecorded: '活动已记录',
    noticeContactRecorded: '联系人角色已记录',
    noticeReconciled: '外部身份已完成对账',
    noticeRelationAdded: '对象关系已添加',
    noticeMetricAssociated: '指标关联已添加',
    noticeTaskAssociated: '任务关联已添加',
    noticeUnlinked: '关联已解除',
    govUpdateObject: '更新业务对象',
    govRetireObject: '退役业务对象',
    unlinkReason: '从对象工作台解除关联',
  },
  boModel: {
    eyebrow: '模型治理 / 配置',
    title: '业务模型目录',
    subtitle: '创建业务线和模型，扩展字段契约，再通过独立审核发布。',
    createLine: '新建业务线',
    stepCreate: '01 / 创建',
    stepCatalog: '02 / 目录',
    panelCreateTitle: '新建模型草稿',
    businessLine: '业务线',
    selectBusinessLine: '选择业务线',
    createDraft: '创建草稿',
    fieldCode: '编码',
    fieldName: '名称',
    placeholderName: '医疗案例',
    fieldOwnerUserId: '负责人用户 ID',
    fieldInitialFields: '初始字段',
    placeholderInitialFields: 'JSON 数组或 CSV，表头：name,label,type,required,analytical,official_role',
    inheritScope: '继承 {name} 的范围：',
    defaultScope: '控制范围',
    panelModel: '模型',
    loadingModels: '正在加载模型目录…',
    noModels: '暂无模型。',
    currentVersion: '当前版本',
    noVersion: '暂无版本',
    publishEvidence: '独立发布依据',
    publishLatestDraft: '发布最新草稿',
    panelMetaTitle: '模型元数据',
    saveMeta: '保存元数据',
    panelDraftTitle: '草稿字段与状态机',
    fieldFieldsJson: '字段 JSON',
    fieldStateMachineJson: '状态机 JSON',
    fieldChangeEvidence: '变更依据',
    placeholderChangeEvidence: '为什么要创建此草稿版本？',
    createDraftVersion: '创建草稿版本',
    panelUploadTitle: '字段定义上传',
    uploadHint: '选择 CSV/XLSX 或粘贴 JSON。服务端会规范化类型、官方角色、分析标记和数据分级。',
    validateFieldImport: '校验字段导入',
    diffEyebrow: '导入 {state}',
    diffTitle: '规范化差异',
    required: '必填',
    optional: '可选',
    analyticalField: '分析字段',
    businessField: '业务字段',
    placeholderEvidence: '独立确认依据',
    confirmImport: '确认导入',
    diffEmpty: '校验上传文件后，这里会显示规范化字段契约和差异。',
    noticeModelCreated: '模型草稿已创建',
    noticeFieldsValidated: '字段定义已通过校验，请先查看差异再确认',
    noticeFieldsRejected: '字段定义导入被拒绝',
    noticeFieldsConfirmed: '字段导入已确认，新的草稿版本已创建',
    noticeVersionPublished: '模型版本已发布',
    noticeMetaSaved: '模型元数据已保存',
    noticeDraftCreated: '草稿版本已创建，仍需独立审核后发布',
    errCreateFieldsRequired: '业务线、编码、名称、负责人和至少一个字段均为必填',
    errImportRejected: '导入被拒绝',
    errChooseXlsx: '请先选择 XLSX 文件',
    errDraftFieldsArray: '草稿字段必须是非空 JSON 数组',
    errFieldMissingName: '第 {index} 个字段缺少名称',
    errFieldDuplicateName: '字段名称重复：{name}',
    errEnumNeedsValues: '枚举字段 {name} 需要 allowed_values',
    errMachineInitialState: '状态机必须声明有效的初始状态',
    errTransitionSourceUndeclared: '状态迁移来源 {from} 未声明',
    errTransitionNotArray: '{from} 的状态迁移必须是数组',
    errTransitionTargetUndeclared: '状态迁移目标 {target} 未声明',
    errTransitionEvidenceBoolean: '{from} → {target} 的依据要求必须是布尔值',
    promptLineId: '业务线 ID（例如 medical_insurance）',
    promptLineName: '业务线名称',
    emptyTarget: '(空)',
    placeholderCsvExample: 'name,label,type,required,analytical,official_role\nnatural_key,自然键,string,true,false,natural_key',
  },
  boDw: {
    eyebrow: '数仓预览 / 受治理交接',
    title: '对象数仓契约',
    subtitle: '在交给现有数仓构建器前，检查分析字段、映射、警告和指纹。',
    publishedModel: '已发布对象模型',
    selectModel: '选择模型',
    generating: '正在生成…',
    generatePreview: '生成预览',
    contractFingerprint: '契约指纹',
    schemaFingerprint: '模式指纹',
    modelVersion: '模型版本',
    sourceContract: '来源契约',
    targetTables: '目标表',
    noTargetTables: '没有返回目标表。',
    fieldSelection: '分析字段选择',
    selectedFields: '已选择 {n} 个字段',
    orgMappingPending: '组织映射待定',
    warnings: '警告',
    contract: '契约',
    noWarnings: '规范化未发现警告。',
    reviewEyebrow: '独立审核',
    confirmHandoff: '确认交接',
    reviewHint: '将此页面链接交给独立审核人。确认会创建受治理的数仓构建记录，审核人不能是预览创建人。',
    placeholderEvidence: '审核依据、工单或批准引用',
    confirming: '正在确认…',
    confirmOpen: '确认并打开数仓构建器',
    emptyHint: '生成预览后查看受治理的分析契约。',
    noticeConfirmed: '数仓契约已确认，正在打开构建工作台',
  },
  importStep: {
    uploadTitle: '选择导入文件',
    uploadSubtitle: '支持 XLSX、CSV、JSON 三种格式。文件最大 10 MB。',
    noFileHint: '没有文件？先下载模板：',
    blankTemplate: '空白模板',
    exampleTemplate: '示例模板',
    tabFile: '文件上传',
    tabJson: '粘贴数据',
    dropText: '拖拽文件到此处，或',
    pickFile: '选择文件',
    dropHint: '支持 .xlsx / .csv / .json，最大 10 MB',
    remove: '移除',
    parsing: '正在解析文件…',
    pasteLabel: '粘贴 JSON 或 CSV 数据',
    parsePreview: '解析预览',
    parseSuccess: '✓ 已解析 {n} 行',
    previewTitle: '数据预览',
    previewMeta: '前 {n} 行 / 共 {total} 行',
    rowsUnit: '{n} 行数据',
    fileMeta: '{name} · {size} · {n} 行',
    jsonPlaceholder: '例如：\n[\n  { "metric_id": "yibao_001", "name": "注册入组", "level": "M1", "business_line_id": "yibao", "status": "computable" },\n  ...\n]',
    errFileTooLarge: '文件过大（{size}），请将单次导入控制在 {max} 以内',
    errFormat: '不支持的文件格式，请上传 .xlsx、.csv 或 .json 文件',
    errJsonArray: 'JSON 必须为数据行数组',
    errContentFormat: '无法识别内容格式，请粘贴有效的 JSON 数组',
    configTitle: '配置导入选项',
    configSubtitle: '设置导入来源和校验选项。',
    sourceLabel: '来源说明',
    sourcePlaceholder: '例如：V26 指标树 v26.3 / 2026-09-24 更新',
    sourceHint: '用于标识本次导入的来源，建议包含版本和日期。',
    canonicalTitle: 'Canonical V26 校验',
    canonicalDesc: '启用 245 个指标的对帐校验，确保导入数量与 V26 规范一致。',
    canonicalCount: '当前文件共 {n} 个指标。Canonical 模式要求恰好 245 个。',
    fileOverview: '文件概览',
    metricTotal: '指标总数',
    businessLineCount: '业务线数',
    levelCount: '层级数',
    computable: '可计算',
    businessLineDist: '业务线分布：',
    levelDist: '层级分布：',
    startValidate: '开始校验 →',
    needSourceHint: '请填写来源说明后开始校验。',
    unassigned: '未分类',
    validationTitle: '校验结果',
    validationSubtitle: '系统已完成对导入数据的全面校验。',
    validating: '正在校验数据，请稍候…',
    stateLabel: '校验状态',
    rowCount: '总行数',
    errorCount: '错误数',
    v26Reconciliation: 'V26 对帐',
    errorDetail: '错误详情',
    errorDetailMeta: '({n} 个错误，{m} 行受影响)',
    colRowNo: '行号',
    colMetricId: '指标ID',
    colError: '错误信息',
    colErrorList: '错误列表',
    global: '全局',
    moreSimilar: '还有 {n} 行同类错误…',
    viewAllErrors: '查看全部错误列表 ({n} 行)',
    validationPassed: '校验通过！',
    validationPassedBody: '所有 {n} 个指标均通过校验，可以查看差异并提交发布。',
    previewTopRows: '数据预览 (前 10 行)',
    backToEdit: '← 返回修改',
    viewDiff: '查看差异 →',
    validationFailed: '校验未通过',
    diffTitle: '差异预览',
    diffSubtitle: '查看本次导入与已发布指标的差异。',
    newMetrics: '新增指标',
    changedMetrics: '变更指标',
    totalChanges: '总变更数',
    changeDetail: '变更明细',
    colAction: '操作',
    colMetricName: '指标名称',
    colLevel: '层级',
    colPrevVersion: '之前版本',
    actionCreate: '新增',
    actionChange: '变更',
    expandHint: '点击行展开查看字段详情',
    impactTitle: '影响分析',
    impactIntro: '本次导入涉及 {n} 个指标。',
    impactChange: '其中 {n} 个为变更指标，可能影响下游依赖计算。',
    impactRecompute: '发布后将自动重新计算所有受影响的派生指标。',
    backToValidation: '← 返回校验',
    confirmSubmit: '确认提交 →',
    publishTitle: '提交发布',
    publishSubtitle: '确认并发布本次指标导入。',
    publishSuccess: '发布成功！',
    publishSuccessBody: '{source} 已成功发布，共 {n} 个指标。',
    viewMetricCatalog: '查看指标目录',
    backToImport: '返回导入',
    importSummary: '导入摘要',
    summarySource: '来源',
    summaryState: '状态',
    summaryMetricCount: '指标数',
    summaryReviewState: '审核状态',
    confirmStatusRejected: '已拒绝',
    confirmStatusConfirmed: '已独立确认',
    confirmStatusPending: '待独立确认',
    independentConfirm: '独立确认',
    independentConfirmHint: '需由独立第三方人员确认本次导入内容。',
    statusConfirmed: '已确认',
    statusPending: '待确认',
    sodTitle: '职责分离提醒',
    sodBody: '您是本次导入的创建人，不能确认自己的变更。请由其他具备权限的人员进行确认。',
    noPermissionTitle: '权限不足',
    noPermissionBody: '您没有指标写入权限，无法确认导入。',
    reviewEvidence: '审阅证据',
    reviewEvidencePlaceholder: '请填写审阅依据，例如：对照 V26 指标树 v26.3 逐项核对，公式与口径一致...',
    submitting: '提交中…',
    submitConfirm: '提交确认',
    confirmedBy: '✓ 已由独立人员确认',
    publishSection: '发布',
    publishSectionHint: '发布后将创建不可变版本并应用到生产环境。',
    statusPublished: '已发布',
    statusToPublish: '待发布',
    statusAwaitConfirm: '等待确认',
    changeTicket: '变更单号',
    changeTicketPlaceholder: '例如：CHG-2026-001',
    publishing: '发布中…',
    publish: '发布',
    needConfirmFirst: '请先完成独立确认。',
    backToDiff: '← 返回差异',
    jobStateRejected: '已拒绝',
    jobStateValidated: '已校验',
    jobStateConfirmed: '已确认',
    jobStatePublished: '已发布',
    jobStateDraft: '草稿',
    jobStateFailed: '失败',
    errUnclosedQuote: '未闭合的 CSV 引号',
    errDuplicateHeader: 'CSV 表头存在重复字段',
    errColumnMismatch: 'CSV 列数不匹配：期望 {expected} 列，实际 {actual} 列',
    classifyRequired: '必填字段缺失',
    classifyMetricId: '指标ID格式错误',
    classifyDuplicate: '重复指标ID',
    classifyLevel: '层级错误',
    classifyAvailability: '状态值错误',
    classifyGap: '阻塞指标缺少缺口说明',
    classifyCalculation: '计算指标缺少定义',
    classifyFormula: '公式解析错误',
    classifyParent: '上级指标不存在',
    classifyCrossLine: '跨业务线上级未声明',
    classifyCycle: '循环依赖',
    classifyOther: '其他错误',
    xlsxWorkbookTooLarge: '工作簿超过 10 MiB 限制',
    xlsxInvalidZip: '无效的 ZIP 文件（未找到目录结束标记）',
    xlsxUnsupportedZip: '不支持的 ZIP 卷或条目数量过多',
    xlsxInvalidEntry: '无效的 ZIP 条目',
    xlsxUnsafeEntry: '不安全的 XLSX 条目：',
    xlsxExpansionLimit: '工作簿解压超限或存在重复条目',
    xlsxInvalidLocalEntry: '无效的本地文件条目',
    xlsxTruncated: 'XLSX 文件被截断',
    xlsxSizeMismatch: 'XLSX 解压后大小不匹配',
    xlsxMissingXml: '缺少 XML 文件：',
    xlsxUnsafeXml: '不安全的 XML：',
    xlsxNoSheet: '未找到工作表',
    xlsxUnsupportedRelation: '不支持的工作表关系',
  },
  dw: {
    heroKicker: 'WAREHOUSE / SOURCE CONTRACT',
    contractKicker: 'CONTRACT',
    stages: {
      entity_governance: '实体与治理',
      input_schema: '原始字段',
      canonical_dws: 'DWD / DWS',
      transformations: '转换规则',
      review: '契约预览',
      provision: '创建数据表',
      initial_load: '首次导入',
      metrics: '选择指标',
      metric_review: '独立审核',
      activation_handoff: '启用交接',
      completed: '已完成',
    },
    state: {
      draft: '草稿',
      ready_for_provision: '可建表',
      provisioning: '建表中',
      ready_for_load: '待导入',
      loading: '导入中',
      ready_for_metrics: '待选指标',
      metrics_review: '待审核',
      ready_for_activation: '待启用',
      blocked: '需处理',
      completed: '已完成',
      pending: '待处理',
      running: '执行中',
      accepted: '已受理，待核实',
      verified: '已核实',
      failed: '失败',
      unknown: '结果待核对',
      submitted: '已提交审核',
      authorized: '已授权发布',
      published: '已发布',
      skipped: '已跳过',
    },
    error: {
      DW_VALIDATION: '请检查字段定义与数据类型',
      DW_CONTRACT_VERSION: '暂不支持此契约版本',
      DW_CONTRACT_FROZEN: '建表已开始，执行契约已冻结',
      DW_STALE_CONTRACT: '契约已变更，请刷新后重试',
      DW_INPUT_CONFLICT: '批次标识已绑定其他数据',
      DW_DUPLICATE_KEY: '业务主键已存在，不能覆盖',
      DW_OPERATION_BUSY: '请先完成或核对此数据源的当前操作',
      DW_OPERATION_UNKNOWN: '执行结果不确定，请先核对回执',
      DW_GATE: '前置步骤尚未完成',
      DW_METRIC_CHANGED: '指标当前版本已变更，请重新选择并审核',
      DW_METRIC_MANAGED: '此版本将在数据源启用时一起发布',
      SCHEMA_DRIFT: '实际表结构与契约不一致',
      DW_ADAPTER_UNAVAILABLE: '数仓连接未配置或不可用',
      DW_SCOPE: '数据超出授权范围',
      DW_DIMENSION_CONFLICT: '同一自然键存在冲突属性，请统一后重新提交',
      DW_DIMENSION_REFERENCE: '维度引用尚无已核实的代理键映射',
      DW_DIMENSION_SCOPE: '维度范围或属性写入权限不匹配',
      DW_DIMENSION_BUSY: '请先核实此维度尚未完成的操作',
      DW_DIMENSION_KEY_COLLISION: '维度键证据冲突，需要人工核查',
      DW_LOAD_FAILED: '导入未完成，请检查回执',
      DW_REPLAY_UNSAFE: '缺少未提交证据，不能重试',
      VERSION_CONFLICT: '记录已更新，请刷新后重试',
      AUTHZ_DENIED: '没有执行此操作的权限',
      FEATURE_DISABLED: '动态数仓构建功能尚未启用',
    },
    heroTitle: '让数据接入有据可循',
    heroSubtitle: '定义契约，核实每一层，由独立人员完成启用。',
    newDraft: '新建草稿',
    restoring: '正在恢复工作台…',
    featureDisabled: '此环境尚未启用动态数仓构建。请联系管理员。',
    continueDraft: '继续已有草稿',
    selectDraft: '选择草稿',
    unnamed: '未命名',
    refreshState: '刷新状态',
    buildSteps: '构建步骤',
    stateFrozen: '契约已冻结',
    stateDirty: '有未保存的修改',
    stateSaved: '所有修改已保存',
    saveDraft: '保存草稿',
    next: '下一步',
    contractSummary: '契约摘要',
    unnamedSource: '未命名数据源',
    pendingFill: '待填写',
    notSaved: '尚未保存',
    generatedBeforeProvision: '建表前生成',
    writePolicy: '追加 · 重复主键拒绝',
    physicalTables: '物理表',
    dimPhysicalTables: '维度物理表',
    contractFingerprint: '契约指纹',
    draftHint: '草稿与回执保存在服务器。保存后可离开，稍后继续。',
    rowUnit: '行',
    receiptTitle: '执行回执',
    dimReceiptDef: '定义 v{version} · 修订 {revision}',
    toAssign: '待分配',
    reconcileRemote: '核对远端结果',
    retryFailedConfirmed: '重试已确认失败的操作',
    dimReceiptNote: '维度更新可能先于事实可见。全部目标核实后才会发布成功运行。',
    field: {
      addHint: '添加字段，定义此层的数据结构。',
      colName: '字段名',
      colSource: '原始列名',
      colSourcePlaceholder: '留空使用字段名',
      colType: '类型',
      colClassification: '分级',
      nullable: '可空',
      remove: '移除',
      removeField: '移除{label}字段 {index}',
      addField: '添加{label}字段',
      ariaName: '{label}字段名 {index}',
      ariaSource: '{label}原始列名 {index}',
      ariaType: '{label}类型 {index}',
      ariaClassification: '{label}分级 {index}',
      ariaNullable: '{label}可空 {index}',
      typeString: '文本',
      typeNumber: '数值',
      typeBoolean: '布尔',
      typeTimestamp: '时间',
      classPublic: '公开',
      classInternal: '内部',
      classSensitive: '敏感',
      labelRaw: '原始',
      labelDwd: 'DWD',
      labelDws: 'DWS',
    },
    trans: {
      title: '转换规则',
      note: '每个输出字段对应一条规则。DWS 主键、组织和事件时间直接保留 DWD 值。',
      generateIdentity: '生成同名复制规则',
      outLayer: '输出层',
      outField: '输出字段',
      selectField: '选择字段',
      op: '操作',
      source: '来源',
      selectSource: '选择来源',
      sourcesOrdered: '按顺序填写来源（逗号分隔）',
      separator: '分隔符',
      left: '左侧',
      operator: '运算符',
      right: '右侧',
      divideByZero: '除零策略',
      rejectBatch: '拒绝批次',
      outputNull: '输出空值',
      enumValues: '枚举值映射',
      unknownHandling: '未知值处理',
      nullValue: '空值',
      defaultValue: '默认值',
      inputFormat: '输入格式',
      outputFormat: '输出格式',
      timezone: '时区',
      removeRule: '移除此规则',
      addRule: '添加转换规则',
      ariaOutput: '转换输出字段 {index}',
      ariaOp: '转换操作 {index}',
      ariaSource: '转换来源 {index}',
      opCopy: '复制',
      opEnumMap: '枚举映射',
      opConcat: '文本连接',
      opIntersection: '布尔交集',
      opArithmetic: '算术',
      opDate: '日期格式',
      opCoalesce: '首个非空值',
      errScalarObject: '请填写键与标量值的 JSON 对象',
      errEnumJson: '枚举映射需为有效 JSON 对象，例如 {"已完成": true, "未完成": false}',
    },
    dim: {
      aria: '维度配置',
      kicker: 'DIM / CURRENT ATTRIBUTES',
      heading: '维度与事实引用',
      scdType1: 'SCD Type 1',
      note1: '维度保存实体当前属性，代理键由系统分配。相同键的冲突属性会拒绝整批；完整行中的空值会清除可空属性。当前维度变化不会自动重算已导入的 DWS 属性。',
      creationPaused: '此环境已暂停新建和新导入；已有回执仍可刷新或核对。',
      reuseLabel: '复用已授权维度',
      selectDimension: '选择维度',
      seeded: '种子',
      derived: '派生',
      attach: '引用维度',
      createDim: '新建维度',
      createLegend: '新建受治理维度',
      nameLabel: '维度标识',
      ownerLabel: '维度责任人',
      purposeLabel: '维度用途',
      sourceLabel: '维度来源',
      fromDwd: '从 DWD 派生',
      seedImport: '独立种子导入',
      inheritNote: '沿用此数据源的业务线、组织与分级；属性写入权威为 {source}。保存后物理字段不可修改，调整结构需新建维度。',
      keyFieldsLabel: 'DIM 自然键',
      keyFieldsNote: '自然键 1–8 个字段，不可空；保留文本大小写、空格与 Unicode。',
      attributesLabel: 'DIM 属性',
      attributesNote: '属性最多 20 个字段。保存定义会创建独立治理记录。',
      saveDef: '保存维度定义',
      cancelDef: '取消定义',
      pinnedVersion: '固定 v{version}',
      removeRef: '移除此维度及绑定',
      definitionMeta: '业务线 {line} · 组织 {org} · {classification} · 属性权威 {authority}',
      ownerNote: '责任人：{owner} · {purpose}',
      writeMode: '属性写入模式',
      modeReference: '只引用已核实的代理键',
      modeDerive: '此数据源派生并更新完整属性',
      keySource: '自然键 {name} 的来源',
      attrSource: '属性 {name} 的来源',
      selectDwdField: '选择 DWD 字段',
      addBinding: '添加事实绑定',
      definitionHidden: '固定定义不可见，请检查权限或刷新维度列表。',
      bindingLegend: '事实绑定 {index} · {title}',
      factLayer: '事实层',
      surrogateColumn: '代理键输出列',
      bindKey: '绑定自然键 {name}',
      requiredRef: '必需引用',
      bindingNote: '输出为 BIGINT 代理键，不占用用户字段。可选引用仅在全部自然键为空时产生空值；非空未知键仍拒绝。',
      removeBinding: '移除事实绑定',
      seedSection: '独立种子导入与回执',
      seedNote: '导入完整自然键与属性行，不需要事实主键或事件时间。种子表可供多个已授权数据源复用。',
      seedDimension: '种子维度',
      selectSeedDimension: '选择种子维度',
      inputFields: '输入字段：',
      seedFile: '种子 CSV / JSON 文件',
      seedBatch: '种子批次标识',
      submitSeed: '提交种子导入',
      refreshSeedReceipt: '刷新种子回执',
      seedReceipt: '种子执行回执',
      revision: '修订 {revision}',
      reconcileSeedRemote: '核对种子远端结果',
      retrySeedFailed: '重试已确认失败的种子',
      noticeSaved: '维度定义已保存。请保存数据源草稿以保留引用与绑定。',
      noticeSeedQueued: '种子导入已排队。刷新回执核实结果；不会创建事实运行。',
      errFileSize: '请选择不超过 4 MB 的 CSV / JSON 文件',
      errJsonRows: 'JSON 需为 1–5000 行完整记录数组',
    },
    view: {
      switchConfirm: '当前修改尚未保存，仍要切换草稿？',
      newConfirm: '当前修改尚未保存，仍要新建？',
      draftSaved: '草稿已保存，可随时返回继续。',
      saveFirst: '请先保存草稿',
      contractInvalid: '契约尚未通过校验，请按字段提示修改。',
      actionSaved: '操作已保存。',
      pollPaused: '自动刷新已暂停，可手动刷新查看进度。',
      fileTooLarge: '文件超过 4 MB，请拆分为更小的批次。',
      chooseFile: '请选择 CSV 或 JSON 文件',
      jsonRows: 'JSON 需为 1–5000 行记录数组',
      refsFormat: '字段引用需按 名称=字段 填写',
      evidenceRequired: '请填写审核依据',
      reviewRecorded: '审核意见已记录。',
      sqlCopied: 'SQL 预览已复制。',
      leaveConfirm: '修改尚未保存，仍要离开？',
      entityName: '数据源名称',
      entityNamePlaceholder: '患者经营记录',
      entitySlug: '实体标识',
      entitySlugPlaceholder: 'patient',
      owner: '责任人',
      sourceSystem: '来源系统',
      sourceSystemPlaceholder: 'crm',
      purpose: '用途',
      purposePlaceholder: '说明此数据用于哪些业务分析',
      businessLineId: '业务线 ID',
      orgScopeComma: '组织范围（逗号分隔）',
      dataClassification: '数据分级',
      grain: '查询粒度',
      grainDay: '日',
      grainMonth: '月',
      grainQuarter: '季',
      grainYear: '年',
      timezone: '时区',
      freshnessMinutes: '新鲜度（分钟）',
      retentionDays: '保留天数',
      schemaVersion: '数据模式版本',
      dwsNote: 'DWS 保持逐条记录，主键、组织和事件时间与 DWD 一致。',
      initMirror: '从原始字段初始化 DWD / DWS',
      primaryKeyComma: '业务主键（逗号分隔）',
      orgField: '组织字段',
      eventTimeField: '事件时间字段',
      validateContract: '校验契约',
      contractValid: '契约已通过校验。',
      copySql: '复制 SQL 预览',
      downloadSql: '下载 SQL 预览',
      ddlPreview: '{layer} 建表预览',
      dimDdlPreview: 'DIM 建表预览 · {id}',
      dimPrepNote: '维度先完成键分配与属性更新，事实表再写入已解析的代理键。',
      referenceRequired: '必需',
      referenceOptional: '可选',
      referenceSuffix: '引用',
      preflightPreview: '{layer} 拒绝数据检查（结果必须为 0）',
      etlPreview: '{layer} 转换预览',
      provisionNote: '创建 ODS、DWD、DWS 以及所需维度表，核实已复用的维度。执行契约从此冻结。',
      createTables: '创建数据表',
      loadNote: '上传 CSV 或 JSON。每批 1–5000 行、请求不超过 4 MB；已存在的业务主键将拒绝导入。',
      selectFile: '选择 CSV / JSON 文件',
      batchId: '批次标识',
      batchIdPlaceholder: '同一数据批次重试时保留此标识',
      submitLoad: '提交导入',
      metricsNote: '选择已有指标并创建新版本。当前版本会继续提供查询，直到数据源启用时一起切换。',
      selectMetric: '选择指标',
      selectExistingMetric: '选择已有指标',
      metricFormula: '指标公式',
      refsPerLine: '字段引用（每行 名称=字段）',
      removeMetric: '移除指标',
      saveSelectedVersions: '保存所选指标版本',
      skipMetrics: '明确跳过指标',
      metricReviewNote: '由作者之外的人员审核，再由发布人员授权；实际版本切换与数据源启用同时提交。',
      reviewStateLabel: '审核状态：',
      reviewEvidence: '审核 / 发布依据',
      changeTicket: '变更单号',
      formulaLabel: '公式：',
      prevVersionLabel: '前一版本：',
      notPublished: '尚未发布',
      confirmedIndependently: '已独立确认',
      pendingIndependentConfirm: '待独立确认',
      confirmVersion: '确认此版本',
      rejectVersion: '拒绝此版本',
      submitIndependentReview: '提交独立审核',
      authorizePublish: '授权启用时发布',
      activationNote: '所有表和初始数据核实后，由独立人员启用数据源。已审核指标在同一事务中切换，任一步失败都会整体回滚。',
      creatorNote: '你是数据源创建人，请将此草稿链接交给独立审核人继续。',
      activationEvidence: '启用依据',
      activateSource: '启用数据源并切换指标版本',
      sourceActivated: '数据源已启用，指标版本已完成切换。',
      completeHint: '完成核实与独立审核后即可启用。',
      viewSources: '查看数据接入',
      addDimCapability: '添加维度能力（契约 v2）',
      businessLine: '业务线',
      org: '组织',
      draftVersion: '草稿版本',
      sourceIdLabel: '数据源 ID',
      fieldsLabel: '字段',
      writePolicyLabel: '写入策略',
      selectField: '选择字段',
      reviewStepNote: '校验所有字段和转换规则后，预览系统生成的 SQL。',
    },
  },
  accessChanges: {
    title: '变更审核与发布',
    colSubject: '对象',
    colTicket: '变更单',
    colAuthor: '发起人',
    colReviewState: '审核状态',
    actionDetail: '详情',
    actionReview: '审核',
    actionPublish: '发布',
    drawerReview: '独立审核',
    drawerPublish: '发布变更',
    drawerDetail: '变更详情',
    fieldDecision: '审核决定',
    decisionConfirm: '确认',
    decisionReject: '拒绝',
    fieldEvidence: '审阅证据',
    publishHint: '发布将使变更生效；相关用户的旧会话与导出权限会重新校验。',
    submitReview: '提交审核',
    submitPublish: '发布变更',
  },
  enum: {
    not_started: '未开始',
    active: '进行中',
    on_hold: '已暂停',
    completed: '已完成',
    closed: '已关闭',
    cancelled: '已取消',
    compass: 'Compass',
    source_system: '来源系统',
    fresh: '新鲜',
    stale: '已过期',
    unknown: '未知',
    resolved: '已对账',
    unresolved: '未对账',
    conflict: '冲突',
    draft: '草稿',
    published: '已发布',
    validated: '已通过校验',
    confirmed: '已确认',
    loaded: '已加载',
    rejected: '已拒绝',
    failed: '失败',
    pending: '等待处理',
    verified: '已核实',
    blocked: '已阻止',
    public: '公开',
    internal: '内部',
    sensitive: '敏感',
    string: '文本',
    integer: '整数',
    number: '数值',
    boolean: '布尔值',
    date: '日期',
    datetime: '日期时间',
    'enum': '枚举',
    note: '备注',
    review: '审核',
    call: '电话',
    meeting: '会议',
    source_sync: '来源同步',
    status_change: '状态变更',
    task_update: '任务更新',
    import: '导入',
    subject: '主体',
    context: '上下文',
    related_to: '相关对象',
    outbound: '出向',
    inbound: '入向',
    'not analytical or not selected': '非分析字段或未选择',
    succeeded: '成功',
    quarantined: '已隔离',
    queued: '排队中',
    passed: '通过',
    pending_approval: '待批准',
    ready: '就绪',
    SUCCESS: '成功',
    change: '变更',
    create: '创建',
    registered: '已登记',
    xlsx: 'XLSX',
    pdf: 'PDF',
  },
  metricStatus: {
    computable: '可计算',
    partial: '部分可用',
    blocked: '数据缺口',
    draft: '草稿',
    forward_looking: '前瞻',
  },
  taskState: {
    not_started: '未开始',
    assigned: '已派发',
    in_progress: '进行中',
    completed: '已完成',
    verified: '已核验',
    closed: '已关闭',
    overdue: '已逾期',
    reopened: '已重开',
    cancelled: '已取消',
  },
  severity: {
    low: '低',
    medium: '中',
    high: '高',
  },
  error: {
    AUTHZ_DENIED: '当前账号没有此操作的权限或数据范围',
    NOT_FOUND: '记录不存在或不在可见范围内',
    OBJECT_NOT_FOUND: '对象不存在或不在可见范围内',
    BUSINESS_OBJECTS_DISABLED: '当前环境未启用业务对象功能',
    BUSINESS_OBJECTS_DW_DISABLED: '当前环境未启用对象数仓功能',
    SEPARATION_OF_DUTIES: '请由另一位有权限的审核人独立确认',
    VERSION_CONFLICT: '记录已更新，请刷新后再操作',
    MODEL_CODE: '编码须以字母开头，并使用安全的标识字符',
    MODEL_EXISTS: '此业务线已存在相同编码的模型',
    MODEL_SCHEMA_INVALID: '字段定义或状态机不符合模型要求，请检查名称、类型、来源和状态迁移',
    MODEL_INPUT_INVALID: '请填写有效的模型名称和负责人',
    MODEL_SCOPE_IMMUTABLE: '创建模型后不能更改所属业务线',
    MODEL_VERSION_IMMUTABLE: '已发布模型须通过新建草稿版本修改',
    MODEL_VERSION_REQUIRED: '模型版本状态不符合要求，请选择已发布版本或待发布草稿',
    OBJECT_SCHEMA_INVALID: '字段值不符合模型要求，请检查必填项、类型和枚举值',
    OBJECT_STATE_INVALID: '当前模型不允许此生命周期状态',
    OBJECT_STATE_EVIDENCE_REQUIRED: '此次状态迁移必须填写依据',
    OBJECT_IDENTITY_INVALID: '请填写有效的自然键',
    OBJECT_DUPLICATE_IDENTITY: '已存在相同身份的对象',
    OBJECT_EXTERNAL_REFERENCE_CONFLICT: '此外部引用已关联其他对象',
    OBJECT_AUTHORITY_DENIED: '来源系统管理的字段不能在此修改',
    OBJECT_SOURCE_CONFLICT: '来源信息缺失或与对象权威来源不一致',
    OBJECT_RECONCILIATION_REQUIRED: '请通过身份对账操作关联或修改来源身份',
    OBJECT_ASSOCIATION_INVALID: '关联不符合要求，请检查业务线、关联角色和版本',
    OBJECT_ASSOCIATION_EXISTS: '此关联已存在',
    OBJECT_RELATION_INVALID: '关系无效，请检查业务线、重复关联或自身关联',
    OBJECT_DW_EVIDENCE_REQUIRED: '请填写独立审核依据',
    OBJECT_DW_PREVIEW_STALE: '预览已变化，请重新生成后确认',
    OBJECT_DW_CLASSIFICATION_BLOCKED: '分析字段的数据分级超出模型策略或尚未获批',
    ACTIVITY_TYPE_INVALID: '请选择允许的活动类型',
    ACTIVITY_SIZE: '活动内容过长，请缩短后重试',
    ACTIVITY_REPLAY_CONFLICT: '相同活动标识对应的内容不一致，请核对来源事件',
    CONTACT_PII_DEFERRED: '当前版本仅支持联系人角色和来源引用',
    IMPORT_NOT_READY: '导入状态尚不允许此操作，请先完成校验和独立确认',
    IMPORT_ROWS: '导入行数不符合要求，请检查文件',
    IMPORT_TYPE_INVALID: '此导入类型不支持当前操作',
    IMPORT_PATH_DENIED: '请上传文件，不支持服务端文件路径',
    SCANNER_REQUIRED: '当前环境未配置文件扫描，请使用 CSV 或联系管理员',
    SCOPE_UNKNOWN: '业务线不存在',
    VALIDATION: '请检查必填项和输入格式',
    NETWORK_ERROR: '无法连接服务，请检查网络后重试',
    CONCURRENCY_LIMIT: '当前并发已达上限，请稍后重试',
    SYNTAX_JSON: 'JSON 格式有误，请检查引号、逗号和括号',
    REQUEST_FAILED: '请求失败，请稍后重试',
    GENERIC_400: '操作未完成，请检查输入和当前记录状态',
    GENERIC_500: '服务暂不可用，请稍后重试',
  },
};
